import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

// Set axios baseURL
// In development: if REACT_APP_API_URL is not set, default to localhost:5000/api
// In production: REACT_APP_API_URL should be set
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Development fallback - backend runs on port 5000
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/api';
  }
  return '/api';
};

axios.defaults.baseURL = getApiUrl();
axios.defaults.withCredentials = true;

// Add axios interceptor to automatically include Bearer token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

if (typeof window !== 'undefined' && window.fetch) {
  const originalFetch = window.fetch;
  window.fetch = (input, init = {}) => {
    const nextInit = { ...init };
    if (!nextInit.credentials) {
      nextInit.credentials = 'include';
    }
    return originalFetch(input, nextInit);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
